<template>
	<div class="step">
		<div class="login-wrapper" v-if="!preAuthenticate">
			<SubHeader/>
			<div class="container">
				<div class="row">
					<form action="#" method="post" @submit.prevent="submit" class="col-md-7 mx-auto py-5">
						<div class="row">
							<div class="col-6">
								<div class="form-field">
									<label for="firstName" class="form-label">First Name</label>
									<input type="text" class="form-control" name="firstName" id="firstName" v-model="firstName" placeholder="Enter your first name" required>
								</div>
							</div>
							<div class="col-6">
								<div class="form-field">
									<label for="lastName" class="form-label">Last Name</label>
									<input type="text" class="form-control" name="lastName" id="lastName" v-model="lastName" placeholder="Enter your last name" required>
								</div>
							</div>
						</div>
						<div class="form-field mt-3 pt-3">
							<label for="phone" class="form-label">Phone</label>
							<input type="text" class="form-control" name="phone" id="phone" v-model="phone" placeholder="201-555-0123" required>
						</div>
						<div class="form-field mt-3 pt-3">
							<label for="email" class="form-label">Email</label>
							<input type="email" class="form-control" name="email" id="email" v-model="email" placeholder="Your email address here" required>
						</div>

						<!-- Form Navigation -->
						<div class="d-flex flex-column flex-md-row justify-content-md-between mt-3">
							<button class="btn btn-primary btn-wide ms-md-auto" type="submit" :disabled="loading">
								<span v-if="!loading">Continue</span>
								<span class="spinner-border" v-if="loading"></span>
							</button>
						</div>
					</form>
				</div>
			</div>
		</div>
		<div class="loading-effect py-5 text-center" v-if="preAuthenticate">
			<div class="spinner-border text-black-50 opacity-25"></div>
		</div>
	</div>
</template>

<script>
import SubHeader from "@/components/SubHeader";
import repository from "@/repository/repository";
import Logs from "@/repository/logs";
export default {
    name: "AuthForm",
    components: {SubHeader},
    beforeMount() {
        // Verify if the current step is finished
        if(this.$store.getters.auth.completed) {
            this.$router.replace("/personal");
        }
    },
    props: ['preAuthenticate',],
	data() {
        return {
            token: this.$store.getters.token,
            firstName: this.$store.getters.personal.firstName,
            lastName: this.$store.getters.personal.lastName,
            phone: this.$store.getters.personal.phone,
            email: this.$store.getters.personal.email,
			loading: false,
		}
	},
	created() {
        if(this.$store.getters.auth.completed) {
            this.$router.push("/details");
		}
        if(this.preAuthenticate) {
            // Verify if user is already signed in
            repository.get("/me", {
                headers: {
                    'Authorization': 'Bearer ' + this.preAuthenticate,
                }
            })
                .then(response => {
                    this.$store.commit("updateAuth", {
                        token: this.preAuthenticate,
                    });
                    this.$store.commit("updateAll", response.data.user);
                    this.$store.commit("setPreAuthenticated");
                    this.$router.replace("/details");
                })
                .catch(error => {
                    this.$store.commit("logoutUser");
                    this.$router.replace("/");
                    Logs.save('onboarding.authForm.preAuthenticate', error.response, null);
                })
        }
	},
    methods: {
        submit() {
            this.loading = true;

            // Submit Request & Proceed
			let payload = {
                email: this.email,
                firstName: this.firstName,
                lastName: this.lastName,
                phone: this.phone,
            };
            repository.post('/lead', payload)
				.then(response => {
                    this.$store.commit("updateLead", {
                        email: this.email,
                        firstName: this.firstName,
                        lastName: this.lastName,
                        phone: this.phone,
                    });
                    this.loading = false;

                    this.$gtag.event('onboarding_new_lead');
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'onboarding_new_lead',
                    });

                    this.$router.push("/personal");

                    // An error happened, but ignore it and continue
                    if(response.data.status === 'error') {
                        Logs.save('onboarding.authForm', response.data, payload);
                    }
				})
				.catch(error => {
                    this.error = error.response.data.code;
                    this.loading = false;
                    Logs.save('onboarding.authForm', error.response, payload);
				})
		},
	},
}
</script>

<style lang="scss">
.password-field {
	position: relative;

	button {
		position: absolute;
		bottom: 0;
		right: 0;
		top: 0;
		margin: auto;
		background: none;
		border: none;
		box-shadow: none;
		outline: none;
		width: 3rem;
		height: 3rem;
		padding: 0.25rem;
		opacity: 0.25;
		transition: 0.2s ease all;

		&:hover {
			opacity: 1;
		}

		img {
			width: 1.5rem;
		}
	}
}

.step {
	h4 {
		font-size: 1.75rem;
		font-weight: bold;
		color: #16193A;

		@media (max-width: 767px) {
			font-size: 1.25rem;
		}
	}
}
</style>